import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IUser, CognitoService } from 'src/app/services/cognito.service';
import { Router, RoutesRecognized } from '@angular/router';

@Component({
    selector: 'app-contractor-home',
    templateUrl: './contractor-home.component.html',
    styleUrls: ['./contractor-home.component.css'],
    standalone: false
})
export class ContractorHomeComponent implements OnInit {
  show_disclaimer: boolean = false;
  currentUser: any = {};

  constructor(private cognitoService: CognitoService, private router: Router) {}

  ngOnInit(): void {
    this.cognitoService.clearUserData();
    this.cognitoService.getUser().then((user) => {
      if (!user) return;
      this.currentUser = user;
      if (user.attributes['custom:accepted_disclaimer'] == 'false') {
        // if first time log in for current user show dialog
        this.show_disclaimer = true;
      }
    });
  }

  async accept_disclaimer(): Promise<void> {
    //if disclaimer is accepted update user details so it wont be shown next time
    this.show_disclaimer = false;
    this.currentUser.attributes['custom:accepted_disclaimer'] = 'true';
    try {
      await this.cognitoService.updateUser({ 'custom:accepted_disclaimer': 'true' });
    } catch {
      this.show_disclaimer = true;
      this.currentUser.attributes['custom:accepted_disclaimer'] = 'false';
    }
  }

  decline_disclaimer(): void {
    //log out user if disclaimer isnt accepted
    this.show_disclaimer = false;
    this.cognitoService.signOut().then(() => {
      localStorage.removeItem(environment.keys.accessKey);
      localStorage.removeItem(environment.keys.secretKey);
      localStorage.removeItem(environment.keys.sessionToken);
      this.router.navigate(['/signIn']);
    });
  }
}
